import { readable, type Readable } from "svelte/store";
import { getSubCollectionAsStore } from "$lib/utils/firestore";

export interface TeamAppKey {
  id: number;
  creator: string;
  expiry: Date;
  modified: Date;
}

export function getTeamAppKeys(teamId: string, appId: string): Readable<TeamAppKey[] | undefined> {
  return readable<TeamAppKey[] | undefined>(undefined, (set) => {
    const apiKeysUnsub = getSubCollectionAsStore(`teams/${teamId}/apps/${appId}/keys`).subscribe((apiKeyItems) => {
      const apiKeys = apiKeyItems.map((i) => {
        return {
          id: parseInt(i.id),
          creator: i.data.creator as string,
          expiry: i.data.expiry.toDate() as Date,
          modified: i.data.modified.toDate() as Date,
        };
      });
      set(apiKeys);
    });
    return () => {
      apiKeysUnsub();
    };
  });
}
